import React from "react";
import { toast } from "react-toastify";
import { Minus, Plus, ShoppingCart } from "lucide-react";
import { useCart } from "../context/CartContext";
import CartToast from "./CartToast";

// Botón "Agregar" de una tarjeta de producto — en cuanto el producto ya está en el
// carrito, se convierte en un stepper +/- para subir/bajar la cantidad sin tener que
// salir de la vista (grilla de tienda, ofertas, favoritos, etc.) ni ir a /cart.
const SIZES = {
  sm: { btn: "py-1.5 rounded-lg text-[10px]", icon: 10, step: "w-6 h-6", qty: "text-[11px]" },
  md: { btn: "py-2 rounded-xl text-[11px]", icon: 12, step: "w-8 h-8", qty: "text-sm" },
};

export default function CartQtyControl({ product, isOpen = true, size = "sm", tone = "light", addClassName = "", className = "" }) {
  const { addToCart, increaseQty, decreaseQty, removeFromCart, getQty } = useCart();
  const s = SIZES[size] || SIZES.sm;
  const productId = product.id ?? product._id;
  const qty = getQty(product);
  const outOfStock = product.stock != null && Number(product.stock) <= 0;
  const canAdd = isOpen && !outOfStock;

  if (qty > 0) {
    const isDark = tone === "dark";
    return (
      <div className={`flex items-center justify-between flex-1 rounded-lg border ${
        isDark ? "border-zinc-700 bg-zinc-800" : "border-gray-200 bg-gray-50"
      } ${className}`}>
        <button
          type="button"
          onClick={() => (qty <= 1 ? removeFromCart(productId) : decreaseQty(productId))}
          className={`${s.step} flex items-center justify-center shrink-0 ${isDark ? "text-gray-300 hover:text-white" : "text-gray-600 hover:text-gray-900"}`}
        >
          <Minus size={s.icon} />
        </button>
        <span className={`${s.qty} font-bold ${isDark ? "text-white" : "text-gray-800"}`}>{qty}</span>
        <button
          type="button"
          disabled={!canAdd}
          onClick={() => canAdd && increaseQty(productId)}
          className={`${s.step} flex items-center justify-center disabled:opacity-30 shrink-0 ${isDark ? "text-gray-300 hover:text-white" : "text-gray-600 hover:text-gray-900"}`}
        >
          <Plus size={s.icon} />
        </button>
      </div>
    );
  }

  return (
    <button
      type="button"
      disabled={!canAdd}
      onClick={() => {
        if (!canAdd) return;
        addToCart(product);
        toast(<CartToast product={product} />, { icon: "🛒", autoClose: 2000 });
      }}
      className={`flex items-center justify-center gap-1 flex-1 font-bold transition ${s.btn} ${className} ${
        canAdd ? addClassName : "bg-gray-100 text-gray-400 cursor-not-allowed"
      }`}
    >
      <ShoppingCart size={s.icon} />
      {outOfStock ? "Agotado" : !isOpen ? "Cerrado" : "Agregar"}
    </button>
  );
}
